import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import Icon from '../../Icon';
import * as api from '../../../services/api';

class DeleteWaveButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.onDelete = this.onDelete.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    onDelete() {
        const {survey, wave, handleDelete} = this.props;
        api.deleteSurveyWave(survey.id, wave.id)
            .then(() => {
                handleDelete();
            });
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    render() {
        const {children, disabled, wave, warning} = this.props;
        return (
            <a onClick={!disabled && this.toggleModal} className={classNames({disabled, 'text-danger': !disabled})}>
                {children}
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.trackers.deleteWaveModal.title} values={{value: wave.name}} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.trackers.deleteWaveModal.body} values={{value: wave.name}} />
                        {warning &&
                            <div className="text-danger bold">
                                <FormattedMessage {...messages.trackers.deleteWaveModal.warning} />
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary delete-button" type="button" onClick={this.onDelete}>
                            <Icon icon="trash" /><FormattedMessage {...messages.surveys.button.remove} />
                        </button>
                    </ModalFooter>
                </Modal>
            </a>
        );
    }
}

export default DeleteWaveButton;
